export default __webpack_public_path__ + "static/media/upvoteIcon.d6034eda.svg";